import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, LOCALE_ID, Input, Renderer2, NgZone } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';

import { countries } from 'src/app/resources/countries';
import { FormModel } from 'src/app/models/form.model';

import { SelectEvent, FileRestrictions, CancelEvent} from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TipoFerramenta } from 'src/app/models/tipoferramenta.model';
import { DialogCloseResult, DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Enum } from 'src/app/models/enum.model';
import { Observable } from 'rxjs';
import { ApiConfig, RequestConfig } from 'src/app/configs';
import { HttpClient } from '@angular/common/http';
import { Keys } from '@progress/kendo-angular-common';
import { CellClickEvent, CellCloseEvent, AddEvent, SaveEvent, RemoveEvent , GridComponent } from '@progress/kendo-angular-grid';
import { AvariasTipoFerramentaViewModel } from 'src/app/models/avariatipoferramenta.model';
import { Site } from 'src/app/models/site.model';

@Component({
    selector: 'app-tools-type-form-component',
    templateUrl: './tools-type-form.component.html'
})
export class ToolTypeFormComponent extends DialogContentBase  implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public editDataItem: any;
    public currentGridRef: GridComponent | undefined ;
    @Input() public isNew = false;
    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
    public phoneNumberMask = '(+9) 0000-000-00-00';
    public fileRestrictions: FileRestrictions = {
        allowedExtensions: ['.png', '.jpeg', '.jpg']
    };
    public avatars?: NodeList;
    public imgURL :string = 'assets/noimage.png';
   public avariasTipoFerramenta = new  Array<AvariasTipoFerramentaViewModel>();
    public formValue: TipoFerramenta =  {
      nome: '',
      idTamanho: 0,
      obs: '',
      refImagem: 0,
      avariasTipoFerramenta: [],
      avarias: [],
      traducoes: [
        { refLingua: 1, valor: '', descricaoLingua: '', id: 0 },
        { refLingua: 2, valor: '', descricaoLingua: '', id: 0 },
        { refLingua: 3, valor: '', descricaoLingua: '', id: 0 }
      ],
      id: 0,
      descricaoTamanho: ''
    };

    public customMsgService: CustomMessagesService;
    listItemsTamanhos: Enum[]= [];

    constructor(private dialogService: DialogService,public msgService: MessageService,private notificationService: NotificationService,public override dialog: DialogRef,private intl: IntlService,private api: ApiService   ,private formBuilder: FormBuilder,private renderer: Renderer2, public zone: NgZone,) {
        super(dialog);
       
       

        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.description = this.customMsgService.translate('selecionartag');

       
    }
    public maxlength = 20;
  public charachtersCount = 0;
  public counter = `${this.charachtersCount}/${this.maxlength}`;
    ngOnInit(): void {
        this.api
        .getRequest<BaseHttpResponse<Enum[]>>("TipoFerramentas/GetTamanhos")
        .then((data) => {
            this.listItemsTamanhos = data.value;
            this.setDraggableRows();

        })
        .catch((err) => {});
   
    }

    public placeHolder: any = {
      descricao: "",
      id: 0,
    };

    public inputBlur()
    {
if(this.formGroup.controls['en'].value== '' && this.formGroup.controls['fr'].value =='' && this.formValue.id==0)
{
var texto = this.formGroup.controls['pt'].value;
this.formGroup.controls['en'].setValue(texto) ;
this.formGroup.controls['fr'].setValue(texto) ;
}
}
    public setDraggableRows(): void {
      const tableRows: Array<HTMLTableElement> = this.getAllRows();
      tableRows.forEach((item: HTMLElement) => {
        this.renderer.setAttribute(item, "draggable", "true");
        this.addDragListeners(item);
      });
    }
    public addDragListeners(item: HTMLElement): void {
      item.addEventListener("dragstart", (e: DragEvent) => {
        const rowItem = item.querySelector("td");
  
        // Prevents dragging Grid header row
        if (rowItem === null) {
          return;
        }
  
        let selectedItem =this.avariasTipoFerramenta.find(
          (i) => i.id === Number(rowItem.textContent)
        );
        let dataItem = JSON.stringify(selectedItem);
        e.dataTransfer?.setData("text/plain", dataItem);
      });
    }
    public getAllRows(): Array<HTMLTableElement> {
      var l = Array.from(document.querySelectorAll(".k-grid tr"));
      return Array.from(document.querySelectorAll(".k-grid tr"));
    }
    public setFormValues() {
      this.avariasTipoFerramenta = new Array<AvariasTipoFerramentaViewModel>();
        var ptValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor;
        var enValue =  this.formValue.traducoes.filter(_ling=> _ling.refLingua === 2)[0].valor;
        var frValue =  this.formValue.traducoes.filter(_ling=> _ling.refLingua === 3)[0].valor;

        this.formValue.avariasTipoFerramenta.forEach(element => {
          //var json = Object.a[ssign({},] element.traducoes);
          

          var ptValue = element.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor;
          var enValue =  element.traducoes.filter(_ling=> _ling.refLingua === 2)[0].valor;
           var frValue =  element.traducoes.filter(_ling=> _ling.refLingua === 3)[0].valor;

           var json :AvariasTipoFerramentaViewModel =
            {
              pt:ptValue ,
              en:enValue,
              fr:frValue ,
              refTipoFerramenta:this.formValue.id,
              id:element.id ,
              codigo:element.codigo,
              observacao:element.observacao};
        
        this.avariasTipoFerramenta.push(json);
        });

         this.formGroup = new FormGroup({
             pt: new FormControl(ptValue),
             en: new FormControl(enValue),
             fr: new FormControl(frValue),
             imagem: new FormControl(null),
             obs: new FormControl(this.formValue?.obs),
             idTamanho:  new FormControl( {id:this.formValue?.idTamanho}),

         });

         this.LoadImage();
     }

    // public setAvatar() {
    //     this.avatars = document.querySelectorAll('.k-avatar .k-avatar-image');
    //     const avatarImg = localStorage.getItem('avatar');
    //     if (avatarImg) {
    //         this.avatars.forEach((avatar: any) => {
    //             avatar.style['background-image'] = `url("${avatarImg}")`;
    //         });
    //     }
    // }


    public saveChanges(): void {

        this.formGroup.markAllAsTouched();
        var imagem = undefined;

        if(this.formGroup.controls['imagem'].value!=undefined)
         imagem= this.formGroup.controls['imagem'].value[0];

         this.avariasTipoFerramenta.forEach(element => {

              var valor = this.formValue.avariasTipoFerramenta.filter(_av => _av.id === element.id)[0];
   
              if(valor!=undefined && element.id!=0)
              {
                valor.traducoes.filter(_av => _av.refLingua === 1)[0].valor= element.pt;
                valor.traducoes.filter(_av => _av.refLingua === 2)[0].valor= element.en;
                valor.traducoes.filter(_av => _av.refLingua === 3)[0].valor= element.fr;
                valor.observacao = element.observacao;
                valor.codigo = element.codigo;
              }
              else
              {
              var json = { 
                  id:0, 
                  codigo:element.codigo,
                  observacao:element.observacao,
                  traducoes: [
                  {refLingua:1,valor: element.pt,descricaoLingua:'',id:0},
                  {refLingua:2,valor:element.en,descricaoLingua:'',id:0},
                  {refLingua:3,valor:element.fr,descricaoLingua:'',id:0}],
                  refTipoFerramenta:element.refTipoFerramenta
                
                };

              if(  this.formValue.avariasTipoFerramenta.filter(_av => _av.codigo === element.codigo).length == 0)
                this.formValue.avariasTipoFerramenta.push(json)
              }
     ;
        });
        

        this.formValue.traducoes.filter(_ling=> _ling.refLingua === 1)[0].valor =this.formGroup.controls['pt'].value ;
        this.formValue.traducoes.filter(_ling=> _ling.refLingua === 2)[0].valor =this.formGroup.controls['en'].value;
        this.formValue.traducoes.filter(_ling=> _ling.refLingua === 3)[0].valor=this.formGroup.controls['fr'].value;
        this.formValue.idTamanho = this.formGroup.controls['idTamanho'].value.id;
        this.formValue.obs =  this.formGroup.controls['obs'].value;

        this.api.saveMultiPart<BaseHttpResponse<TipoFerramenta>>("TipoFerramentas/SavetipoDeFerramenta",this.formValue, imagem).then((res) => {
          if (res.ok) {

            this.notificationService.show({
                content:this.customMsgService.translate('registoGravadoComSucesso') ,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'bottom' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
            });
            this.dialog.close();


          } else {
            this.notificationService.show({
              appendTo: this.container,
              content:res.message ,
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'top' },
              type: { style: 'error', icon: true },
              hideAfter: 4000
      
          });
          }
        });
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

    public isFileAllowed(file: any): boolean {
        return <boolean>this.fileRestrictions.allowedExtensions?.includes(file.extension);
    }

    public selectAvatar(ev: SelectEvent): void {
        const  reader = new FileReader();
        const file = ev.files[0];
        const avatars = this.avatars;
        if (file.rawFile && this.isFileAllowed(file)) {

            reader.onload = (_event) => {
                this.imgURL  = reader.result?.toString() as string;
            //   t his.imgURL = reader.result;
        }
            reader.readAsDataURL(file.rawFile);


        }
    }

    LoadImage() {
        if (this.formValue.refImagem == null) return;

        this.api
          .getBytes("Imagem/DownloadImage?refImage=" + this.formValue.refImagem)
          .then((blob) => {
            const binaryData = [];
            binaryData.push(blob);
            this.preview(new Blob(binaryData, { type: "image/png" }));
          });
      }

      preview(file:any) {
        const mimeType = file.type;
        if (mimeType.match(/image\/*/) == null) {
          //this.message = "Only images are supported.";
          return;
        }

        const reader = new FileReader();
       // this.imagePath = file;


        reader.readAsDataURL(file);
        reader.onload = (_event) => {
            this.imgURL  = reader.result?.toString() as string;
        //   this.imgURL = reader.result;
        //   this.showImage = true;
        };
      }
      // public onStateChange(state: State): void {
      //   // this.gridState = state;
    
      //   // this.editService.read();
      // }
    
      public addHandler(): void {
         this.editDataItem =   {PT:'' , EN:'',FR:'' , refTipoFerramenta:this.formValue.id, ID:0};
         this.isNew = true;
      }
    
      public editHandler(args: AddEvent): void {
        this.editDataItem = args.dataItem;
        this.isNew = false;
      }
    
      public cancelHandler(): void {
        this.editDataItem = undefined;
      }
    
      public saveHandler(updatedDataItem: any): void {
       // this.editService.save(product, this.isNew);
          if(this.isNew)
          {
            this.avariasTipoFerramenta.push(updatedDataItem);
          }
          else
          {
            Object.assign(  this.editDataItem ,updatedDataItem);
          }

          this.formGroup.markAsDirty();
          this.editDataItem = undefined;
      }
    
      public removeHandler(args: RemoveEvent): void {
       this.delete(args.dataItem);
      }

      public noRecordsMsg = "No records available yet. Please drop a row.";
      public onDragStart(e: DragEvent, grid: GridComponent): void {
        this.currentGridRef = grid;
        const draggedElement: string = (e.target as HTMLElement).innerText;
        if (draggedElement.includes("ID") || draggedElement === this.noRecordsMsg) {
          e.preventDefault();
        }
      }
    
      public onDrop(
        e: DragEvent,
        dragStartGridRef: GridComponent
      
      ): void {
      }
    
      public onDragOver(e: DragEvent, grid: GridComponent): void {
      }

  public delete(e :any): void {

    var sim  =this.customMsgService.translate('yes');
    var nao  =this.customMsgService.translate('no');
    const dialog: DialogRef = this.dialogService.open({
        appendTo: this.container,
        title:   this.customMsgService.translate('confirmacao') ,
        content: this.customMsgService.translate('desejaRemover') ,
        actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
        width: 450,
        height: 200,
        minWidth: 250,
      });
  
      dialog.result.subscribe((result) => {
        if (result instanceof DialogCloseResult) {
     
        } else if (result.text == sim) {
        

            this.api.cruddelete<BaseHttpResult>('AvariaTipoFerramenta', e.id).
            then(res => {
              if (res.ok) {

                this.notificationService.show({
                    appendTo: this.container,
                    content:this.customMsgService.translate('registoApagadoComSucesso') ,
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'top' },
                    type: { style: 'success', icon: true },
                    hideAfter: 2000
                });
                
                this.avariasTipoFerramenta = this.avariasTipoFerramenta.filter(obj => {return obj !== e});
             
              } else {

                this.notificationService.show({
                    appendTo: this.container,
                    content:res.message ,
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'top' },
                    type: { style: 'error', icon: true },
                    hideAfter: 4000
            
                });

              }
             
            }).
            catch(err => {
            });



        }
  
      
      });
}
}
